<div mat-dialog-content>
    {{ modalText }}
</div>
<div mat-dialog-actions>
    <button #no
            *ngIf="!isAlertDialog"
            mat-button
            matDialogClose
            type="button">
        {{ 'global_dialog_no' | translate }}
    </button>
    <button [matDialogClose]="true"
            [attr.cdkFocusInitial]="!focusNoButton ? true : null"
            mat-button
            type="button">
        {{ safeGuardOk((isAlertDialog ? 'global_dialog_ok' : 'global_dialog_yes') | translate) }}
    </button>
</div>
